import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-locator-pop-over',
  templateUrl: './locator-pop-over.component.html',
  styleUrls: ['./locator-pop-over.component.less']
})
export class LocatorPopOverComponent  {

  @Input() locator: any ;
  @Input() pwLocator: any ;
  @Input() triggers = 'mouseenter:mouseleave';
  @Input() by = true;

  constructor() { }

  

}
